<template>
  <div class="mt-15">
<!--    <div v-if="name" class="flex align-center mt-0 mb-10 black-text">
      <h4 class="mt-0 mb-0 mr-5">Name:</h4>
      {{ name }}
    </div>-->

    <div class="flex align-center">
      <el-button
        class="mr-5"
        type="primary"
        circle
        :icon="isPlaying ? 'mdi mdi-pause' : 'mdi mdi-play'"
        :disabled="!blob"
        @click="isPlaying ? pause() : play()"
      />
      <el-tooltip
        placement="top"
        content="Press and Hold To Record"
        class="flex align-center justify-center"
      >
        <div>
          <VueRecordAudio
            ref="vueRecorder"
            mode="hold"
            @stream="gotStream"
            @result="onDoneRecording"
          />
        </div>
      </el-tooltip>
      <el-tooltip placement="top" content="Upload File">
        <el-upload
          class="ml-5 mr-5"
          action="hailFred"
          accept="audio/*"
          :auto-upload="false"
          :on-change="showUploadedFile"
          :show-file-list="false"
        >
          <el-button class="mr-0" circle icon="el-icon-upload2" />
        </el-upload>
      </el-tooltip>

      <div class="ml-30">
        <el-tooltip placement="top" content="Save as current">
          <el-button
            type="primary"
            circle
            icon="mdi mdi-content-save"
            v-loading="saveProcessing"
            :disabled="saveProcessing || !blob"
            @click="save"
          />
        </el-tooltip>

        <el-tooltip v-if="blob" placement="top" content="Cancel Changes">
          <el-button
            type="danger"
            circle
            icon="mdi mdi-cancel"
            @click="cancelChanges"
          />
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vmRecordOrUpload",

  props: {
    isPlaying: { required: true },
    recordedName: { required: true },
    saveProcessing: { required: true },
    saveSucceded: { required: true },
  },

  data() {
    return {
      name: null,
      blob: null,
    };
  },

  watch: {
    saveSucceded(saveSucceded) {
      if (saveSucceded) {
        this.cancelChanges();
      }
    },
  },

  methods: {
    play() {
      if (this.blob) {
        this.$emit("play", {
          type: "choice",
          blob: window.URL.createObjectURL(this.blob),
        });
      }
    },

    pause() {
      this.$emit("pause");
    },

    gotStream() {
      this.pause();
      this.blob = null;
      this.name = null;
    },

    onDoneRecording(data) {
      this.blob = data;
      this.name = this.recordedName;
    },

    showUploadedFile(file) {
      if (this.isPlaying) {
        this.pause();
      }
      this.blob = new Blob([file.raw]);
      this.name = file.name;
    },

    save() {
      if (this.blob) {
        this.pause();
        this.$emit("save", { type: "custom", file: this.blob });
      }
    },

    cancelChanges() {
      this.pause();
      this.blob = null;
      this.name = null;
    },
  },
};
</script>
